export default __webpack_public_path__ + "static/media/17.1b0f2bc3.png";